module.exports = __webpack_public_path__ + "assets/cis_member_logo.a75e54c7e11c976905f137f41232cb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cis_member_logo.png
// module id = 107
// module chunks = 0